import React, { Component } from 'react'
import './pricingBanner.css'
import PricingTag from './banner-multiday-tag.png'
import { Columns } from 'components/elements';

class PricingBanner extends Component {

    constructor(props) {
        
      super(props);
        this.state = {
            options : this.props.isMobile ? this.createMobileMapOptions : this.createDesktopMapOptions,
        };
      }


    render () {
        return (
          <div className="pricing-banner-cta">
            <Columns className="is-mobile">
              <Columns.Column size={3}>
                <img src={PricingTag} alt="Multiday Pricing Call Out" />
              </Columns.Column>
              <Columns.Column size={9} className="cta-message">
                <p className="is-size-6 my-0">{this.props.message}</p>
              </Columns.Column>
            </Columns>
          </div>
        )
    }
}

export default PricingBanner

PricingBanner.defaultProps = {
  message : 'Missing Message'
}

//Eventually do background color, icon, and message as props, if needed.